# GraphQL query to get all the emails for a given stage

#import "../fragments/nutshell-marketing-start-triggers-fragment.graphql"

query DripSequenceStartTriggersForStageset($stagesetId: ID!) {
    stageset(id: $stagesetId) {
        id
        editableProcessTemplate {
            id
            nutshellMarketingStartTriggers {
                ...NutshellMarketingStartTriggerFragment
                type
                conditions {
                    id
                    config {
                        ... on ConditionConfigEntityFilter {
                            filter {
                                ... on EntityFilterFieldConfigRelationship {
                                    relationshipData
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
